import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import cloneDeep from 'lodash/cloneDeep'
import lodashDebounce from 'lodash/debounce'
import TaskApi from '@/api/task'
import moment from 'moment'
let id: any = 0
import AreaApi from '@/api/area'
import VisitorApi from '@/api/visitor'
import { checkCarNo, debounce } from '@/utils/util'
import { caseNoReg, taskRequest, contactPhonePattern } from '@/utils/regExp'
import isEmpty from 'lodash/isEmpty'
import { nameLength } from '@/config/global'
import { FIRST_VISIT, QUAN_LIU_CHEN, DAN_DIAN } from '@/utils/const'
import SprFestModal from '@/components/Modal/SprFestModal.vue'
import { beforeAddTask } from '@/utils/order'
import { MOTION, NEW_MOTION } from '@/utils/const'
import { Base64 } from 'js-base64'

const debounceSearch = debounce(300)

@Component({
	components: {
		SprFestModal,
	},
})
export default class AddTaskMixin extends Vue {
	public addForm: any = {}
	public addLoading: boolean = false
	public phoneId: number = 0
	public hasNoCarNo: boolean = false
	public isInjured: boolean = false
	public searchArea: any = []
	public noData: boolean = false
	public searchHospital: any = []
	public localSearch: any = ''
	public fetching: boolean = false
	public sameWithPublisher: boolean = false
	public isManualInput: boolean = false
	public areaName: string = ''
	public areaData: any = ''
	public resurvey: boolean = false
	public taskType: any = ''
	public nameLength: any = nameLength
	public taskRequest: any = taskRequest
	public contactPhonePattern: any = contactPhonePattern
	public caseNoReg: any = caseNoReg
	public caseNoList: any[] = []
	public autoFilled = false // 记录信息是否为选中报案号后自动填充

	// 判断所选的就诊医院所在地区与所选的就诊地区是否匹配
	public areaWarning: '' | 'warning' | 'success' | 'error' | 'validating' = ''
	public areaHelpMes = ''
	public hospitalOption: any = null

	public caseWaring: '' | 'warning' | 'success' | 'error' | 'validating' = ''
	public caseHelpMes = ''

	@Prop()
	public data!: any

	@Prop()
	public resurveyOrder!: any

	@Prop()
	public visible!: boolean

	@Prop()
	public parentOrderId!: any

	@Prop()
	private toDetailOnOk!: boolean

	@Prop()
	private detailPath!: string

	@Prop()
	private replaceRoute!: boolean

	@Prop({ default: '' })
	private param!: any

	@Watch('resurveyOrder')
	private onResurveyOrderChange() {
		this.handleResurvey()
	}

	public activated() {}

	public get isCarInsurance() {
		return this.data.insuranceType === '01'
	}

	public get isLiabilityInsurance() {
		return this.data.insuranceType === '02'
	}

	public get isResurveyOrder() {
		return !!this.resurveyOrder
	}

	public get showEffectTime() {
		if (this.resurveyOrder) {
			const isRiskDisposal = !!this.resurveyOrder.riskDetailId
			// const isFuture =
			// 	moment(this.resurveyOrder.effectTime).diff(new Date(), 'days') >= 1
			// // 是否为预约单
			// const isAppointment = this.resurveyOrder.isWholeProcess && isFuture
			return isRiskDisposal
		} else {
			return false
		}
	}

	public beforeSubmit(values: any) {
		return values
	}

	public moment(timestamp: any) {
		return moment(timestamp)
	}

	public disabledEffectDate(effectVal: any) {
		return (
			effectVal.format('YYYY-MM-DD') !==
				moment(new Date()).format('YYYY-MM-DD') &&
			effectVal.valueOf() < new Date()
		)
	}

	public onCheckUrgent(e: Event) {
		const target = e.target as any
		this.addForm.setFieldsValue({
			urgentTask: target.checked ? '1' : '0',
		})
	}

	public onCheckTogether(e: Event) {
		const target = e.target as any
		this.addForm.setFieldsValue({
			withOwner: target.checked ? '1' : '0',
		})
	}

	public onTaskAdd(e: any) {
		e.preventDefault()
		this.addForm.validateFields(async (err: any, values: any) => {
			if (!err) {
				// validateFields存在异步校验
				// 避免快速多次的点击创建多个相同任务
				if (this.addLoading) {
					return
				}
				if (
					this.taskType === FIRST_VISIT &&
					values.orderType === QUAN_LIU_CHEN
				) {
					// 初次探视检查是否有全流程权限
					const { data: hasRight } = await TaskApi.hasWholeProcessRight()
					if (!hasRight) {
						this.$message.error('暂未开通该业务，如有需求请与中保运营人员联系')
						return
					}
				}
				values = cloneDeep(values)
				const codes = values.code.key.split('-')
				values.provinceCode = codes[0]
				values.cityCode = codes[1]
				values.countryCode = codes[2]
				delete values.code
				const hospital = this.addForm.getFieldValue('hospital')
				if (hospital && typeof hospital !== 'string') {
					values.hospital = hospital.label
					const locArr = hospital.key.split('-')
					values.longitude = locArr[0]
					values.latitude = locArr[1]
				}

				const injuredPhoneArray = this.addForm.getFieldValue(
					'injuredPhoneArray'
				)

				values.injuredPhone = injuredPhoneArray
					.reduce((arr: any, item: any) => {
						if (!isEmpty(item)) {
							arr.push(item)
						}
						return arr
					}, [])
					.join(',')
				delete values.injuredPhoneArray
				values.taskType = this.taskType
				if (this.resurveyOrder) {
					values.parentOrderId = this.resurveyOrder.orderId
					if (this.resurveyOrder.riskDetailId) {
						values.riskDetailId = this.resurveyOrder.riskDetailId
						values.effectTime = values.effectTime.format('YYYY-MM-DD')
					}
				}
				values.insuranceType = this.data.insuranceType
				// 二级险种
				values.subInsuranceType = this.data.subInsuranceType
				// 车险为服务手册，非车险为联络卡
				values.isSendManual = this.data.manual2Injured ? 1 : 0
				values = this.beforeSubmit(values)

				if (this.resurveyOrder.noRequest) {
					// 在填写未决回访详情时由客服发起的新建 非保司发起的二次住院
					this.$emit('submit', { values, err })
					return
				}

				if (this.resurveyOrder.finalData) {
					values = Object.assign({}, values, this.resurveyOrder.finalData)
				}

				// 对接需要传的参数
				values.businessId = this.param.businessId

				this.addLoading = true

				let p: any = ''
				if (values.taskType === MOTION) {
					p = TaskApi.addActivity(values)
				} else if (values.taskType === NEW_MOTION) {
					p = TaskApi.addHomeSurvey(values)
				} else {
					p = TaskApi.addTask(values)
				}

				p.then((res: any) => {
					if (res.code === 409) {
						this.$confirm({
							title: '确认框',
							content: res.message,
							onOk: () => {
								values.force = '1'
								this.addLoading = true
								let repeatPro: any = ''
								if (values.taskType === MOTION) {
									repeatPro = TaskApi.addActivity(values)
								} else if (values.taskType === NEW_MOTION) {
									repeatPro = TaskApi.addHomeSurvey(values)
								} else {
									repeatPro = TaskApi.addTask(values)
								}
								return repeatPro
									.then((data: any) => {
										this.$message.success(data.message || '发布成功')
										this.onOk({
											id: data.data.id,
											taskType: this.taskType,
										})
									})
									.finally(() => {
										this.addLoading = false
									})
							},
							onCancel() {},
						})
					} else {
						this.$message.success(res.message || '发布成功')
						this.onOk({
							id: res.data.id,
							taskType: this.taskType,
						})
					}
				}).finally(() => {
					this.addLoading = false
				})
			} else {
				if (err.code) {
					this.areaWarning = 'error'
					this.areaHelpMes = err.code.errors[0].message
				}
				if (err.caseNo) {
					this.caseWaring = 'error'
					this.caseHelpMes = err.caseNo.errors[0].message
				}
				if (
					this.resurveyOrder.isWholeProcess &&
					!this.resurveyOrder.isSecondary
				) {
					// 在填写未决回访详情时由客服发起的新建 非保司发起的二次住院
					// 表单校验不通过 清空值
					this.$emit('submit', { values: null, err })
					return
				}
			}
		})
	}

	public prevStep() {
		this.$emit('prevStep')
	}

	public async handleResurvey() {
		let res: any
		let data: any
		if (this.resurveyOrder.riskDetailId) {
			res = await TaskApi.getTaskDetail(this.resurveyOrder.orderId)

			let order: any = res.data.order,
				injured: any = res.data.injured,
				injuredInfo: any = injured.injuredInfo || {}
			data = {
				clinicArea: order.clinicArea,
				department: order.department || injuredInfo.factVisitingDepartment,
				injuredName: order.injuredName || injured.name,
				caseNo: order.caseNo,
				carNo: order.carNo,
				hospital: order.hospital || injuredInfo.factVisitingHospital,
				longitude: order.longitude || injuredInfo.longitude,
				latitude: order.latitude || injuredInfo.latitude,
				provinceCode: order.provinceCode,
				cityCode: order.cityCode,
				countryCode: order.countryCode,
				ownerName: order.ownerName,
				ownerPhone: order.ownerPhone,
				injuredPhone: order.injuredPhone || injured.selfPhone,
				insuranceType: order.insuranceType,
			}
		} else if (this.resurveyOrder.isWholeProcess) {
			const obj: any = { orderId: this.resurveyOrder.orderId }
			if (this.resurveyOrder.revisitId) {
				obj.revisitId = this.resurveyOrder.revisitId
			}
			res = await TaskApi.getFirstTaskInfo(obj)
			data = Object.assign({}, res.data, this.resurveyOrder.extraData || {})
		} else {
			res = await TaskApi.getOrderExStatusInfo(this.resurveyOrder.orderId)
			data = res.data
		}
		// const data = res.data

		this.$nextTick(() => {
			this.areaData = {
				cityCode: data.cityCode,
				areaCode: data.countryCode,
			}

			const fields: any = {
				department: data.department,
				injuredName: data.injuredName,
				caseNo: data.caseNo,
				carNo: data.carNo,
			}
			this.addForm.setFieldsValue(fields)
			if (this.resurveyOrder.isWholeProcess) {
				fields.firstVisitOrderNo = data.orderNo
			}
			if (data.hospital) {
				fields.hospital = {
					label: data.hospital,
					key: data.longitude + '-' + data.latitude,
				}
			}
			if (data.clinicArea) {
				fields.code = {
					key: [data.provinceCode, data.cityCode, data.countryCode].join('-'),
					label: data.clinicArea,
				}
			}
			if (data.carNo === '无牌') {
				this.onHasCarNoChange({
					target: {
						checked: true,
					},
				})
			} else {
				fields.carNo = data.carNo
			}
			fields.ownerName = data.ownerName
			fields.ownerPhone = data.ownerPhone

			this.addForm.setFieldsValue(fields)
			if (data.injuredPhone) {
				const phones = data.injuredPhone.split(',')
				const ids: any = []
				const phoneArr: any = []
				// this.phoneId = 0
				for (const p of phones) {
					id++
					ids.push(id)
					phoneArr[id] = p
					// ids.push(this.phoneId)
					// phoneArr[this.phoneId] = p
					// this.phoneId++
				}
				this.addForm.setFieldsValue({
					injuredPhone: ids,
				})
				this.$nextTick(() => {
					this.addForm.setFieldsValue({
						injuredPhoneArray: phoneArr,
					})
				})
			}
		})
	}

	public created() {
		this.addForm = this.$form.createForm(this)
		this.sameWithPublisher = true
		this.setPublisher()
		this.addForm.getFieldDecorator('injuredPhone', {
			initialValue: [id],
			preserve: true,
		})
		this.addForm.getFieldDecorator('urgentTask', { preserve: true })
		this.addForm.getFieldDecorator('withOwner', { preserve: true })
		// 设置订单类型
		if (this.taskType !== FIRST_VISIT) {
			this.addForm.getFieldDecorator('orderType', {
				initialValue:
					this.resurveyOrder && this.resurveyOrder.isWholeProcess
						? QUAN_LIU_CHEN
						: DAN_DIAN,
				preserve: true,
			})
		}

		// 是否为二次住院
		this.addForm.getFieldDecorator('secondary', {
			initialValue:
				this.resurveyOrder && this.resurveyOrder.isSecondary ? '1' : '0',
			preserve: true,
		})
		if (this.resurveyOrder) {
			this.handleResurvey()
		}

		this.handleParam()

		this.caseWaring = 'warning'
		this.caseHelpMes = '注: 如非本地承保案件，委派前建议先获取承保机构同意'
	}

	private handleParam() {
		// 从handleResurvey复制而来
		if (this.param) {
			const data = this.param
			this.$nextTick(() => {
				this.areaData = {
					cityCode: data.cityCode,
					areaCode: data.countryCode,
				}

				const fields: any = {
					department: data.department,
					injuredName: data.injuredName,
					caseNo: data.caseNo,
					carNo: data.carNo,
					visitRequest: data.visitRequest,
				}
				this.addForm.setFieldsValue(fields)
				if (data.hospital && data.longitude && data.latitude) {
					fields.hospital = {
						label: data.hospital,
						key: data.longitude + '-' + data.latitude,
					}
				}
				if (
					data.clinicArea &&
					data.provinceCode &&
					data.cityCode &&
					data.countryCode
				) {
					fields.code = {
						key: [data.provinceCode, data.cityCode, data.countryCode].join('-'),
						label: data.clinicArea,
					}
				}
				if (data.contact && data.contactPhone) {
					this.sameWithPublisher = false
					fields.contact = data.contact
					fields.contactPhone = data.contactPhone
				}
				if (data.carNo === '无牌') {
					this.onHasCarNoChange({
						target: {
							checked: true,
						},
					})
				} else {
					fields.carNo = data.carNo
				}
				fields.ownerName = data.ownerName
				fields.ownerPhone = data.ownerPhone

				this.addForm.setFieldsValue(fields)
				if (data.injuredPhone) {
					const phones = data.injuredPhone.split(',')
					const ids: any = []
					const phoneArr: any = []
					for (const p of phones) {
						id++
						ids.push(id)
						phoneArr[id] = p
					}
					this.addForm.setFieldsValue({
						injuredPhone: ids,
					})
					this.$nextTick(() => {
						this.addForm.setFieldsValue({
							injuredPhoneArray: phoneArr,
						})
					})
				}
			})
		}
	}

	public onHospitalSelect(res: any) {
		this.$nextTick(() => {
			this.addForm.setFieldsValue({
				hospital: {
					label: res.title,
					key: res.point.lng + '-' + res.point.lat,
				},
			})
			this.hospitalOption = res
			this.setAreaWarning()
		})
	}

	public onAreaSelect(res: any) {
		const code = res.code.split('-')
		this.areaData = {
			cityCode: code[1],
			areaCode: code[2],
		}
		this.searchHospital = []
		this.setAreaWarning()
	}

	public setAreaWarning() {
		if (!this.hospitalOption || !this.areaData) {
			// 尚未选择就诊医院或就诊地区
			return
		}

		const areaCode = this.areaData.areaCode
		if (
			this.hospitalOption.areaCode &&
			this.hospitalOption.areaCode !== areaCode
		) {
			this.areaWarning = 'warning'
			this.areaHelpMes = `目前就诊医院地址与所在就诊地区不符，正确就诊地区为:“${this.hospitalOption.location}”，为保证订单及时流转，请正确点选地区与医院地址`
		} else {
			this.areaWarning = ''
			this.areaHelpMes = ''
		}
	}

	public onIsInjuredChange(e: any) {
		this.isInjured = e.target.checked

		if (this.isInjured) {
			const injuredPhone = this.addForm.getFieldValue('injuredPhone')
			const firstPhoneId = injuredPhone[0]
			const injuredPhoneArray = this.addForm.getFieldValue('injuredPhoneArray')
			const phone = this.addForm.getFieldValue('ownerPhone')
			injuredPhoneArray[firstPhoneId] = phone

			this.addForm.setFieldsValue({
				injuredName: this.addForm.getFieldValue('ownerName'),
				injuredPhoneArray,
			})
		}
	}

	public onOwnerNameInput(e: any) {
		if (this.isInjured) {
			this.addForm.setFieldsValue({
				injuredName: e.target.value,
			})
		}
	}

	public onOwnerPhoneInput(e: any) {
		if (this.isInjured) {
			const injuredPhone = this.addForm.getFieldValue('injuredPhone')
			const firstPhoneId = injuredPhone[0]
			const injuredPhoneArray = this.addForm.getFieldValue('injuredPhoneArray')
			const phone = this.addForm.getFieldValue('ownerPhone')
			injuredPhoneArray[firstPhoneId] = phone

			this.addForm.setFieldsValue({
				injuredPhoneArray,
			})
		}
	}

	public onHasCarNoChange(e: any) {
		this.hasNoCarNo = e.target.checked
		this.addForm.setFieldsValue({
			carNo: e.target.checked ? '无牌' : '',
		})
	}

	public setPublisher() {
		this.$nextTick(() => {
			if (this.sameWithPublisher) {
				this.addForm.setFieldsValue({
					contact: this.$store.state.user.userInfo.name,
					contactPhone: this.$store.state.user.userInfo.mobile,
				})
			} else {
				this.addForm.setFieldsValue({
					contact: undefined,
					contactPhone: undefined,
				})
			}
		})
	}

	public onWithPublisherChange(e: any) {
		this.sameWithPublisher = e.target.checked
		this.setPublisher()
	}

	public onManualInputChange(e: any) {
		this.isManualInput = e.target.checked
		this.addForm.resetFields('hospital')
	}

	public get debouncedCaseNoSearch() {
		return lodashDebounce(this.searchCaseNo, 200)
	}

	public searchCaseNo(caseNo: string) {
		TaskApi.getCaseNoList({ caseNo }).then((res: any) => {
			this.caseNoList = res.data
		})
	}

	/* 报案号输入搜索 */
	public caseNoSearch(key: string) {
		// 报案号限制50位以内
		this.addForm.setFieldsValue({ caseNo: key.slice(0, 50) })
		if (this.autoFilled) {
			// 修改报案号时清空填充内容
			this.setFilled({})
			this.autoFilled = false
		}
		if (!key) {
			this.caseNoList = []
			return
		}
		this.debouncedCaseNoSearch(key)
	}

	// 选择报案号
	private onCaseNoSelect(item: any) {
		this.autoFilled = true
		this.setFilled(item)
	}

	private setFilled(info: any) {
		let code: any = undefined,
			hospital: any = undefined
		if (info.provinceCode && info.cityCode && info.countryCode) {
			code = {
				label: info.clinicArea,
				key: `${info.provinceCode}-${info.cityCode}-${info.countryCode}`,
			}
		}
		if (info.latitude && info.longitude) {
			hospital = {
				label: info.hospital,
				key: info.longitude + '-' + info.latitude,
			}
			this.isManualInput = false
		} else {
			// 无经纬度则认为是手动输入
			hospital = info.hospital
			this.isManualInput = !!info.hospital
		}

		if (info.carNo === '无牌') {
			this.onHasCarNoChange({
				target: {
					checked: true,
				},
			})
		} else {
			this.hasNoCarNo = false
		}

		this.addForm.setFieldsValue({
			ownerName: info.ownerName,
			ownerPhone: info.ownerPhone,
			carNo: info.carNo,
			code: code,
			hospital: hospital,
		})
	}

	/*就诊地区输入搜索*/
	public areaSearch(value: any) {
		return new Promise((resolve: any, reject: any) => {
			debounceSearch(() => {
				AreaApi.searchArea(value).then((res: any) => {
					if (res.data.length) {
						this.noData = false
						this.searchArea = res.data.map((item: any) => {
							return {
								code: item.provCode + '-' + item.cityCode + '-' + item.areaCode,
								area: item.provName + '-' + item.cityName + '-' + item.areaName,
								cityName: item.cityName,
							}
						})
					} else {
						this.noData = true
						this.searchArea = []
					}
					resolve()
				})
			})
		})
	}

	public hospitalSearch(value: any) {
		if (!value) {
			return
		}
		return new Promise((resolve: any, reject: any) => {
			debounceSearch(() => {
				this.fetching = true
				AreaApi.hospitalTips({
					hospitalName: value,
					...this.areaData,
				})
					.then((res: any) => {
						this.searchHospital = res.data.map((item: any) => {
							return {
								title: item.hospitalName,
								point: {
									lng: item.longitude,
									lat: item.latitude,
								},
								address: item.address,
								areaCode: item.areaCode,
								location: item.location,
							}
						})
						resolve()
					})
					.finally(() => {
						this.fetching = false
					})
			})
		})
	}

	public removePhone(k: any) {
		// can use data-binding to get
		const injuredPhone = this.addForm.getFieldValue('injuredPhone')
		// We need at least one passenger
		if (injuredPhone.length === 1) {
			return
		}

		// can use data-binding to set
		this.addForm.setFieldsValue({
			injuredPhone: injuredPhone.filter((key: any) => key !== k),
		})
	}

	public addPhone() {
		// can use data-binding to get
		const injuredPhone = this.addForm.getFieldValue('injuredPhone')
		const nextPhone = injuredPhone.concat(++id)
		// can use data-binding to set
		// important! notify form to detect changes
		this.addForm.setFieldsValue({
			injuredPhone: nextPhone,
		})
	}

	public checkCarNo(rule: string, value: string, cb: any) {
		const carNo = value && value.toUpperCase()
		if (value !== carNo) {
			this.addForm.setFieldsValue({
				carNo,
			})
			this.addForm.validateFields(['carNo'])
		}

		if (!carNo) {
			cb(new Error('请输入标的车牌号'))
		} else if (carNo === '无牌') {
			cb()
		} else if (!checkCarNo(carNo)) {
			cb(new Error('请输入正确的标的车牌号'))
		} else {
			cb()
		}
	}

	public hasVisitor(rule: any, value: any, callback: Function) {
		// 所选地区是否有作业人员
		const codes = value.key && value.key.split('-')
		const provinceCode = codes[0]
		const cityCode = codes[1]
		const areaCode = codes[2]
		let p = VisitorApi.hasVisitorInArea({
			provinceCode,
			cityCode,
			areaCode,
		})
		p.then((res: any) => {
			if (res.data) {
				this.areaWarning = ''
				this.areaHelpMes = ''
				return callback()
			} else {
				this.areaHelpMes =
					'该地区暂时不具备条件作业，如有需要请联系中保车服工作人员。'
				this.areaWarning = 'error'
				return callback(
					new Error(
						'该地区暂时不具备条件作业，如有需要请联系中保车服工作人员。'
					)
				)
			}
		})
	}

	public checkCaseNo(rule: any, value: any, callback: Function) {
		var reg = /^[^\u4e00-\u9fa5]+$/
		if (!!value && !reg.test(value)) {
			this.caseWaring = 'error'
			this.caseHelpMes = '不能输入中文字符'
			return
		}
		this.caseWaring = 'warning'
		this.caseHelpMes = '注: 如非本地承保案件，委派前建议先获取承保机构同意'
		console.log('注: 如非本地承保案件，委派前建议先获取承保机构同意')
		return callback()
	}

	public onOk(res: any) {
		this.$emit('ok')
		if (
			this.resurveyOrder &&
			this.resurveyOrder.isWholeProcess &&
			!this.resurveyOrder.isSecondary
		) {
			return
		}
		// this.sameWithPublisher = true
		// this.setPublisher()
		// this.isInjured = false
		// this.hasNoCarNo = false
		// this.addForm.resetFields()
		this.$multiTab.closeCurrentPage()
		if (this.toDetailOnOk) {
			const path = `${this.detailPath || '/AiiTasks/TasksDetail'}/${res.id}/${
				res.taskType
			}`
			if (this.replaceRoute) {
				this.$router.replace(path)
			} else {
				this.$multiTab.open(path)
			}
		} else {
			if (this.resurveyOrder && this.resurveyOrder.riskDetailId) {
				this.$multiTab.open(
					`/AiiTasks/TasksDetail/${this.resurveyOrder.orderId}/${this.resurveyOrder.taskType}`
				)
			} else {
				this.$multiTab.open('/AiiTasks/TasksList')
			}
		}
	}
}
